import useLudoGame from "./useLudoGame";
import LudoBoardSVG from "./LudoBoardSVG";

export default function LudoApp() {
  const game = useLudoGame(4);

  return (
    <div className="min-h-screen bg-zinc-900 text-white p-4 space-y-4">
      <h2 className="text-center text-xl">Turn: {game.turn}</h2>

      <LudoBoardSVG tokens={game.tokens} />

      {!game.winner && (
        <button
          onClick={game.rollDice}
          className="mx-auto block px-6 py-3 bg-indigo-600 rounded-xl"
        >
          Roll Dice
        </button>
      )}

      {game.winner && (
        <div className="text-center text-green-400 text-xl">
          🏆 {game.winner} wins
        </div>
      )}
    </div>
  );
}
